import imageBar1 from '../images/bar1.jpg';
import highLookNight3 from '../images/highLookNight3.jpg';
import ice from '../images/ice.jpg';
import massage3 from '../images/massage3.jpg';
import massageBed2 from '../images/massageBed2.jpg';
import massageBed1 from '../images/massageBed1.jpg';
import oilBath from '../images/oilBath.jpg';
import outdoorShower from '../images/outdoorShower.jpg';
import pool1 from '../images/pool1.jpg';
import seatingArea from '../images/seatingArea.jpg';
import jacuzzi from '../images/jacuzzi.jpg';
import games from '../images/games.jpg';

const galleryData = [
    {
        url: pool1,
        category: "בריכה",
        title: { he: "בריכה מרווחת", en: "Spacious Pool" },
        description: {
            he: "בריכה גדולה ומפנקת לשחייה והנאה לאורך כל היום",
            en: "A large and luxurious pool for swimming and enjoying all day long"
        }
    },
    {
        url: jacuzzi,
        category: "בריכה",
        title: { he: "ג'קוזי מפנק", en: "Luxurious Jacuzzi" },
        description: {
            he: "ג'קוזי חמים ומפנק להרפיה ושחרור מתחים",
            en: "A warm and luxurious jacuzzi for relaxation and stress relief"
        }
    },
    {
        url: outdoorShower,
        category: "מתקנים",
        title: { he: "מקלחת חיצונית", en: "Outdoor Shower" },
        description: {
            he: "מקלחת חיצונית מרעננת בסמוך לבריכה בעיצוב טבעי",
            en: "Refreshing outdoor shower near the pool with natural design"
        }
    },
    {
        url: ice,
        category: "מתקנים",
        title: { he: "אמבט קרח", en: "Ice Bath" },
        description: {
            he: "אמבט קרח טיפולי לשיפור זרימת הדם והתאוששות הגוף",
            en: "Therapeutic ice bath for improved circulation and body recovery"
        }
    },
    {
        url: massage3,
        category: "עיסויים",
        title: { he: "עיסוי", en: "Massage" },
        description: {
            he: "עיסוי ארומטי עם שמנים חיוניים לשיפור זרימת הדם והרפיית הגוף",
            en: "Aromatic massage with essential oils to improve circulation and relax the body"
        }
    },
    {
        url: massageBed2,
        category: "חדרי טיפולים",
        title: { he: "מיטת עיסוי", en: "Massage Bed" },
        description: {
            he: "מיטת עיסוי נוחה ומפנקת לחוויית טיפול מרגיעה",
            en: "Comfortable and pampering massage bed for a relaxing treatment experience"
        }
    },
    {
        url: massageBed1,
        category: "חדרי טיפולים",
        title: { he: "מיטת עיסוי", en: "Massage Bed" },
        description: {
            he: "מיטת עיסוי נוחה ומפנקת לחוויית טיפול מרגיעה",
            en: "Comfortable and pampering massage bed for a relaxing treatment experience"
        }
    },
    {
        url: oilBath,
        category: "טיפולים",
        title: { he: "אמבט שמנים", en: "Oil Bath" },
        description: {
            he: "אמבט שמנים מפנק לטיפוח העור והרפיית הגוף",
            en: "Pampering oil bath for skin nourishment and body relaxation"
        }
    },
    {
        url: highLookNight3,
        category: "נופים",
        title: { he: "נוף לילה", en: "Night View" },
        description: {
            he: "נוף לילי מואר באורות רכים, יוצר אווירה קסומה ומרגיעה",
            en: "A night view lit by soft lights, creating a magical and calming atmosphere"
        }
    },
    {
        url: seatingArea,
        category: "אזור ישיבה",
        title: { he: "פינות ישיבה מוצלות", en: "Shaded Seating Areas" },
        description: {
            he: "פינות ישיבה נוחות ומוצלות למנוחה והנאה באוויר הפתוח",
            en: "Comfortable shaded seating areas for relaxing and enjoying the outdoors"
        }
    },
    {
        url: games,
        category: "בילוי",
        title: { he: "משחקים על שפת הבריכה", en: "Games by the Pool" },
        description: {
            he: "מגוון משחקי קופסה להנאה משותפת לצד הבריכה",
            en: "A variety of board games for shared fun by the pool"
        }
    },
    {
        url: imageBar1,
        category: "בר",
        title: { he: "בר משקאות", en: "Drinks Bar" },
        description: {
            he: "בר משקאות עשיר עם מבחר משקאות מרעננים ואלכוהוליים",
            en: "A rich bar offering a variety of refreshing and alcoholic drinks"
        }
    }
];

export default galleryData;
